import { collection, addDoc } from "firebase/firestore";
import { db } from "../firebase/config";
import { getDocs, deleteDoc, doc } from "firebase/firestore";

export const saveLead = async (data) => {
  return await addDoc(collection(db, "leads"), {
    ...data,
    createdAt: new Date(),
  });
};

export const getLeads = async () => {
  const snapshot = await getDocs(collection(db, "leads"));

  return snapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));
};

export const deleteLead = async (id) => {
  await deleteDoc(doc(db, "leads", id));
};
